import styled from 'styled-components';

interface QuantityInputProps {
  error?: boolean;
}

export const Container = styled.div<QuantityInputProps>`
  position: relative;

  .hefesto-stepper__label-wrapper {
    display: none;
  }

  input[name='increaseDrecreaseInput'] {
    ${({ error, theme }) =>
      error &&
      `
    border: 1px solid ${theme.colors.red};
    outline-color: ${theme.colors.red};
  `}
  }
`;
